import { createContext } from 'react-router';

import type { User } from '@/common/user';

export type AuthContextType = {
  token?: string;
  user?: User | null;
};

export const authContext = createContext<AuthContextType | null>(null);
